import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../../updateAction';
import { Dialog } from '@reach/dialog';
import ModalFAQs from '../../components/ModalFAQs';

import BackButton from '../../components/BackButton';
// import Disclaimer from '../../components/Disclaimer';
import Button from '../../components/Button';
import RadioGroup from '../../components/RadioGroup';
import StackForm from '../../components/StackForm';
import Title from '../../components/Title';
import OfferOption from '../../components/OfferOption';
import BannerTarjeta from '../../components/BannerTarjeta';
import { getNumberWithDots } from '../../helpers';
import { LANDING_URL /* NO_TIENE_CUENTA_MESSAGE */ } from '../../config';

import { useGlobalData } from '../../../store';

const Offers = props => {
  const [modal, setModal] = useState(false);
  const { setGlobalData } = useGlobalData();

  const { register, errors, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);

  const onSubmit = data => {
    document.querySelector('.progress-indicator').style.width = '100%';
    action(data);

    if (window.openModal) {
      window.openModal('tarjeta_credito');
    } else {
      console.error('Falta la ventana modal de Inicio de Sesión.');
    }
  };

  const noTieneVisa = !state?.data?.tarjeta?.includes('tarjeta-visa') || false;
  // const noTieneCuenta = state?.data?.tipo_cuenta?.includes('tipo_cuenta-no') || false;
  // NOTE: Nunca le preguntamos si tiene cuenta en este flujo
  // const noTieneCuenta = false;

  const renderOffers = () => {
    // if (noTieneCuenta) return <Disclaimer message={NO_TIENE_CUENTA_MESSAGE} />;

    if (noTieneVisa) return null;

    const response = state?.data?.response;

    const { tasas_prestamos_TC, solicitud_original } = response;

    const monedaSolicitada = solicitud_original?.moneda; // URGP || US.D
    let monedaSimbolo;

    switch (monedaSolicitada) {
      case 'URGP':
        monedaSimbolo = '$ ';
        break;
      case 'US.D':
        monedaSimbolo = 'U$S ';
        break;
      default:
        monedaSimbolo = '';
        break;
    }

    let tarjetaOptions = [];

    tasas_prestamos_TC.forEach((tasa, i) => {
      tarjetaOptions.push({
        value: tasa.plazo,
        id: 'option-tarjeta-' + i,
        component: (
          <OfferOption
            installments={tasa.plazo}
            price={monedaSimbolo + getNumberWithDots(tasa.monto_cuota)}
            total={monedaSimbolo + getNumberWithDots(tasa.monto_total)}
            rate={tasa.interes + '%'}
          />
        ),
      });
    });

    return (
      <>
        {tasas_prestamos_TC?.length > 0 && (
          <div>
            <div className="options-subtitle">Préstamo en Tarjeta de Crédito</div>
            <p className="options-more">
              Ver{' '}
              <button
                onClick={e => {
                  e.preventDefault();
                  setModal(true);
                }}
              >
                más información
              </button>{' '}
              de este producto
            </p>

            <RadioGroup
              type="card"
              name="plazo"
              options={tarjetaOptions}
              register={register({ required: 'Debe seleccionar una oferta para continuar.' })}
              error={errors.plazo}
              onChange={e => {
                const plazo = e.target.value;
                action({ plazo });
                setGlobalData({ plazo });
              }}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>
          {noTieneVisa
            ? 'Ups, no sos cliente. Seguí alguno de estos pasos.'
            : 'Para terminar elegí la mejor oferta para ti.'}
        </Title>

        {renderOffers()}

        {/* Si no tiene Visa */}
        {noTieneVisa && <BannerTarjeta />}
      </div>

      <div className="form-actions">
        {noTieneVisa ? (
          <Button href={LANDING_URL} block id="next-button-step-2">
            terminar
          </Button>
        ) : (
          <Button block type="submit" id="next-button-step-2">
            lo quiero ya
          </Button>
        )}

        <BackButton />
      </div>

      <Dialog isOpen={modal} onDismiss={() => setModal(false)} aria-label="Información adicional">
        <ModalFAQs onDismiss={() => setModal(false)} defaultTab={0} />
      </Dialog>

      <style jsx global>{`
        .options-subtitle {
          font-weight: bold;
          font-size: 18px;
          color: #56504c;
          margin-bottom: 0;
        }

        .options-subtitle + :global(.banner) {
          margin-top: 10px;
        }

        .options-more {
          font-size: 15px;
          color: #757575;
          margin-bottom: 14px;
          margin-top: 0;
        }

        .options-more button {
          font: inherit;
          padding: 0;
          border: 0;
          background: transparent;
          cursor: pointer;
          color: #106eb0;
          text-decoration: none;
        }

        .options-more button:hover {
          text-decoration: underline;
        }
      `}</style>
    </StackForm>
  );
};

export default withRouter(Offers);
